/** Canonical JSON: sorted object keys, `-0` normalised to `0`, no whitespace. */
export function canonicalJson(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    if (typeof value === 'number') {
      if (!Number.isFinite(value)) throw new Error(`canonicalJson: non-finite number ${value}`);
      return Object.is(value, -0) ? '0' : JSON.stringify(value);
    }
    if (value === undefined) return 'null';
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return `[${value.map((v) => canonicalJson(v)).join(',')}]`;
  }
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record)
    .filter((k) => record[k] !== undefined)
    .sort();
  return `{${keys.map((k) => `${JSON.stringify(k)}:${canonicalJson(record[k])}`).join(',')}}`;
}

function fnv1a32(text: string, basis: number): number {
  let hash = basis >>> 0;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

/** 64-bit (two independent FNV-1a lanes) hex digest of a string. */
export function hashString(text: string): string {
  const a = fnv1a32(text, 0x811c9dc5);
  const b = fnv1a32(text, 0x050c5d1f);
  return a.toString(16).padStart(8, '0') + b.toString(16).padStart(8, '0');
}

export function hashValue(value: unknown): string {
  return hashString(canonicalJson(value));
}
